import React from 'react';
import { timeMapping } from '../../components/TimeSelect/timeMapping';

interface ITimeProps {
  time?: string;
}

const Time: React.FC<React.PropsWithChildren<ITimeProps>> = ({ time }) => {
  if (!time) {
    return null;
  }
  return <>{timeMapping?.[time]}</>;
};
export default Time;
